;(function () {
    const SELECTOR = ".text-appear-animation"
    const WORD_CLASS =
        "inline-block motion-safe:opacity-0 motion-safe:blur-[6px] motion-safe:translate-y-[0.32em] " +
        "motion-safe:transition-[opacity,filter,transform] motion-safe:duration-[1100ms] motion-safe:ease-expo " +
        "motion-safe:delay-[calc(min(var(--i),12)*60ms)] " +
        "group-[.is-active]:opacity-100 group-[.is-active]:blur-0 group-[.is-active]:translate-y-0"

    // Walks el's child nodes so <br> line breaks and separate <p> blocks
    // (both common in richtext settings) survive the rebuild below instead of
    // being silently flattened away by el.textContent.
    function tokenize(el) {
        const tokens = []

        function walk(node) {
            if (node.nodeType === Node.TEXT_NODE) {
                node.textContent
                    .split(/\s+/)
                    .filter(Boolean)
                    .forEach((word) => tokens.push(word))
                return
            }
            if (node.nodeType !== Node.ELEMENT_NODE) return

            if (node.tagName === "BR") {
                tokens.push({ break: true })
                return
            }

            node.childNodes.forEach(walk)

            const isBlock = node.tagName === "P" || node.tagName === "DIV"
            if (isBlock && node.nextSibling) tokens.push({ break: true })
        }

        el.childNodes.forEach(walk)
        return tokens
    }

    function split(el) {
        if (el.dataset.split === "true") return // safe to call more than once

        const tokens = tokenize(el)
        if (!tokens.length) return

        el.classList.add("group") // group-[.is-active]: on the words keys off this
        el.textContent = ""

        // Wrapper preserves the space text-nodes if a flex-centered parent would
        // otherwise collapse whitespace between inline children.
        const inner = document.createElement("span")
        inner.className = "block"
        let i = 0
        tokens.forEach((token, idx) => {
            if (token.break) {
                inner.appendChild(document.createElement("br"))
                return
            }

            const span = document.createElement("span")
            span.className = WORD_CLASS
            span.style.setProperty("--i", i)
            span.textContent = token
            inner.appendChild(span)
            i++

            const next = tokens[idx + 1]
            if (next && !next.break)
                inner.appendChild(document.createTextNode(" "))
        })
        el.appendChild(inner)
        el.dataset.split = "true"
    }

    function activate(el) {
        split(el)

        // If this is the element's first-ever split (e.g. a manual trigger
        // firing right as the element connects), the words have never been
        // painted in their initial state yet. Adding is-active in the same
        // tick gives the browser no "before" frame to transition from, so it
        // jumps straight to the end state with no visible animation. Waiting
        // two frames guarantees a real paint of the initial state first.
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                el.classList.add("is-active")
            })
        })
    }

    function reset(el) {
        el.classList.remove("is-active")
    }

    function init(root) {
        const els = (root || document).querySelectorAll(SELECTOR)
        if (!els.length) return

        els.forEach(split)

        const auto = Array.from(els).filter(
            (el) =>
                el.dataset.appear !== "manual" && el.dataset.split === "true"
        )
        if (!auto.length) return

        const observer = new IntersectionObserver(
            (entries, obs) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return
                    entry.target.classList.add("is-active")
                    obs.unobserve(entry.target)
                })
            },
            { threshold: 0.4 }
        )
        auto.forEach((el) => observer.observe(el))
    }

    document.addEventListener("DOMContentLoaded", () => init())
    // Re-run for sections re-rendered by the Shopify theme editor (they don't
    // trigger a fresh DOMContentLoaded, so newly injected markup is otherwise skipped).
    document.addEventListener("shopify:section:load", (event) =>
        init(event.target)
    )

    window.TextAppear = { split, activate, reset, init }
})()
